module.exports = __webpack_public_path__ + "img/qq_detail.e3a8cfe.svg";